import React from 'react';


class SportTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeLine: null
    }
  }

  _highlightLine(index) {
    this.setState({activeLine: index});
  }

  _renderItem(item, index){
    const { lang } = this.props;
    const { logo, name, positions, certificates, levels, status } = item.node;

    let imageSrc = logo ? logo : '';
    let showName = '';
    if(name){
      showName = name[lang];
    }
    let position = positions.length ? positions[0][lang] : '';
    let certificate = '';
    if(certificates.length && certificates[0].name){
      certificate = certificates[0].name[lang];
    }
    let level = '';
    if(levels.length){
      level = levels[0][lang].name;
    }

    let activeClass = (this.state.activeLine == index) ? 'active' : null;

    return (
      <tr className={activeClass}
        key={index}
        onClick={()=>{this._highlightLine(index); this.props.onItemClick(item, index)}}>
          <td>{index}</td>
          <td>{status}</td>
          <td><img src={imageSrc} style={{height:20}}/></td>
          <td>{showName}</td>
          <td>{position}</td>
          <td>{certificate}</td>
          <td>{level}</td>
      </tr>
    )
  }

  render() {
    const dataSource = this.props.dataSource;
    return (
      <table className="table table-hover table-condensed">
        <thead>
          <tr>
            <th>NO.</th>
            <th>Status</th>
            <th>Icon</th>
            <th>Name</th>
            <th>Positions</th>
            <th>Certifications</th>
            <th>Levels</th>
            <th>&nbsp;</th>
          </tr>
        </thead>

        <tbody>
          {dataSource.map((item, index, arr) => this._renderItem(item, index))}
        </tbody>
      </table>
    )
  }


}

SportTable.propTypes = ({
  dataSource : React.PropTypes.array.isRequired,
  lang : React.PropTypes.string.isRequired,
  onItemClick: React.PropTypes.func.isRequired,
});




export default SportTable;



// WEBPACK FOOTER //
// ./src/components/SportTable.js